import React, { useEffect, useState, useRef } from 'react'
import swal from 'sweetalert';
import { Link } from 'react-router-dom'
import { options } from '../../../constants';
import Loader from '../../../component/Loader/Loader'
import Breadcrumb from '../../../component/Breadcrumb';
import MappingTabing from '../../../component/MappingTabing'
import { Box, Button, Grid, Typography } from '@mui/material'
import MappingHomePageTable from './MappingHomePageTable';
import STHomePageModal from '../../STHomePage/STHomePageModal';
import { fetchAutoCompleteHomePage } from '../../../api/mappingApi';
import { checklocalStorageItems, saveContentFile } from '../../../utlis';

const HomePage = () => {
    const inputRef  = useRef(null);
    const [showLoader, setShowLoader]        = useState(false);
    const [editRowIndex,setEditRowIndex]     = useState('');
    const [stHomePageData,setSTHomePageData] = useState([]);
    const [open, setOpen]                    = useState(false);
    const [sheetFilter, setSheetFilter]      = useState('');
    const [searchValue, setSearchValue]      = useState('');
    const [itemForLocal, setItemForLocal]    = useState(false);
    const [sheetMappingData, setSheetMappingData]       = useState([]);
    const [autoCompleteLoading, setAutoCompleteLoading] = useState(false);
    const [fieldsModal, setFieldsModal]  = useState({
        Sheet     :    '',
        PId       :    '',
    });

    useEffect(() => {
        const fetchAutoCompleteData = () => {
            if(searchValue === ''){
                setSheetMappingData([]);
                return;
            }
            let active;
            if(sheetFilter){
                active = true;
                ( async () => {
                        setAutoCompleteLoading(true);
                        const data = await fetchAutoCompleteHomePage(sheetFilter,searchValue);
                        if(active){
                            setSheetMappingData(data);
                            setAutoCompleteLoading(false);
                        }
                    }
                )();
            }
            return () => {
                active = false;
            }
        };
        
        fetchAutoCompleteData();
    },[sheetFilter,searchValue]);

    
    useEffect(() => {
        const dataInLocalStorage = checklocalStorageItems();
        setItemForLocal(dataInLocalStorage);
        fetchHomePageData();
        window.addEventListener('storage',fetchHomePageData);
        return () => {
            window.removeEventListener('storage',fetchHomePageData);
        }
    },[])

    const fetchHomePageData = () => {
        setShowLoader(true);
        let homePageData = JSON.parse(localStorage.getItem('HomePage'));
        if(homePageData != null && homePageData.length > 0){
            setSTHomePageData(homePageData);
        }
        setShowLoader(false);
    }

    const handleRowEdit = (rowIndex) => {
        setEditRowIndex(rowIndex)
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleRowDelete = (rowIndex) => {
        const newArray = [...stHomePageData];
        newArray.splice(rowIndex, 1);
        setSTHomePageData(newArray);
        if(newArray.length === 0){
            localStorage.removeItem("HomePage");
        } else {
            localStorage.setItem('HomePage',JSON.stringify(newArray));
        }
    }

    const handleChangeAutoComplete = (values) => {
        if(values) {
            Object?.keys(values)?.map(val => val === 'PId' ? setFieldsModal((prevState) =>  ({...prevState, [val]: values[val] })) : '');
        }
    }

    const handleSearchValueAutoComplete = (value) => {
        setSearchValue(value);
    }

    const changeHandler = (name,value) => {
        if(name === 'Sheet'){
            setSheetFilter(value)
        }
        setFieldsModal((prevState) =>  ({...prevState, [name]: value }));
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleAddModalFormData = () => {
        let error = (fieldsModal.Sheet === '' || fieldsModal.PId === '') ? true : false;
        if(error){
            swal("Oops!", "Please fill required fields!", "error");
            return false;
        }
        let duplicatePID;
        duplicatePID =  stHomePageData.some(val => val.PId === parseInt(fieldsModal.PId) ? true : false);
        if(duplicatePID){
            swal("Oops!", "PID is already used. Please select different PID number.", "error");
            return false;
        }
        if(editRowIndex !== ''){
            let newArray = [...stHomePageData];
            newArray[editRowIndex] = {"PId": parseInt(fieldsModal.PId)};
            setSTHomePageData(newArray);
        } else {
            setSTHomePageData(stHomePageData => [...stHomePageData, {"PId": parseInt(fieldsModal.PId)} ]);
        }
        setOpen(false);
        
    }

    useEffect(() => {
        if(stHomePageData != null && stHomePageData.length > 0){
            localStorage.setItem('HomePage',JSON.stringify(stHomePageData));
        }
    },[stHomePageData])



    useEffect(() => {
        if(!open){
            setFieldsModal({
                Sheet   :    '',
                PId     :    '',
            });
            setSheetFilter('');
            setSheetMappingData([]);
            setEditRowIndex('');
        }        
    },[open]);

    const handleConfigFileContent = async() => {
        setShowLoader(true);
        const result = await saveContentFile();
        setShowLoader(false);
        if(result){
            swal({
              title: "Success",
              text: result.message,
              icon: "success",
            })
        }
    }

    return (
        <>
            {showLoader && 
                <Loader />
            }
            <Breadcrumb  title="Configuration ST Homepage">
                <Typography component={Link} to="/" variant="subtitle2" color="primary"  className="link-breadcrumb">
                Dashboard
                </Typography>
                <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
                Homepage
                </Typography>
            </Breadcrumb>
            <MappingTabing 
                value="homepage" 
                handleConfigFileContent={handleConfigFileContent}
            />
            <Box  component="section">
                <Grid className="contentBox">
                    {itemForLocal &&
                        <Grid className="modbusButtons" container direction="row" display={'flex'} justifyContent={'flex-end'}>
                            <Grid item>
                                <Button
                                    onClick={handleClickOpen}
                                    variant="contained"
                                    size="small"
                                    color="primary"
                                    sx={{mr:3}}
                                >Add New 
                                </Button>
                            </Grid>
                   
                            {/* <Grid item>
                                <Button
                                    disabled={fields.length === 0 ? true : false}
                                    onClick={handleFormData}
                                    variant="contained"
                                    size="large"
                                    color="secondary"
                                >Submit
                                </Button>
                            </Grid> */}
                        </Grid>
                    }
                    {/* {fields?.length > 0 && fields?.every(val => val.RegAddr !== '')  &&
                        <STHomePageRows 
                            fields={fields}
                            handleDeleteInput={handleDeleteInput}
                        />
                    } */}
                    {stHomePageData.length === 0  &&
                        <p>No Data Available.</p>
                    }
                    <MappingHomePageTable 
                        data={stHomePageData}
                        handleRowEdit={handleRowEdit}
                        handleRowDelete={handleRowDelete}
                    />
                </Grid>
            </Box>
            <STHomePageModal
                open={open}
                inputRef={inputRef}
                fields={fieldsModal} 
                onClose={handleClose}
                options={options}
                changeHandler={changeHandler}  
                autoCompleteOptions={sheetMappingData}
                autoCompleteLoading={autoCompleteLoading}
                handleAddModalFormData={handleAddModalFormData}
                handleChangeAutoComplete={handleChangeAutoComplete}
                handleSearchValueAutoComplete={handleSearchValueAutoComplete}
            />
        </>
    )
}

export default HomePage